/*
 * @Author: alex
 * @Date: 2022-09-13 11:21:47
 * @LastEditors: alex
 * @LastEditTime: 2022-11-14 10:33:02
 * @Description:
 * Copyright (c) 2022 by piesat, All Rights Reserved.
 */
import WebGLVectorLayerRenderer from 'ol/renderer/webgl/VectorLayer'
import { packColor } from 'ol/renderer/webgl/shaders'
import Layer from 'ol/layer/Layer'
import type { WebGLVectorStyleType } from '../mapSpecification'

export interface WebGLVectorLayerOptions {
  style: WebGLVectorStyleType
  [_: string]: any
}

/**
 * webgl vector layer
 */
export class WebGLVectorLayer extends Layer {
  private readonly style: WebGLVectorStyleType
  constructor(options: WebGLVectorLayerOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const { style, ...rest } = options
    super(rest)
    this.style = style
  }

  createRenderer(): WebGLVectorLayerRenderer {
    console.log('style', this.style)
    return new WebGLVectorLayerRenderer(this, {
      fill: {
        attributes: {
          color: () => {
            return packColor(this.style.fill?.color ?? [255, 255, 195, 0.8])
          },
          opacity: () => {
            return this.style.fill?.opacity ?? 1.0
          }
        }
      },
      stroke: {
        attributes: {
          color: () => {
            return packColor(this.style.stroke?.color ?? [112, 128, 144, 0.8])
          },
          width: () => {
            return this.style.stroke?.width ?? 1.0
          },
          opacity: () => {
            return this.style.stroke?.opacity ?? 1.0
          }
        }
      }
    })
  }
}
